// Additional categories from xpeditionz.co.nz
const BASE = "https://www.xpeditionz.co.nz";

export const ROOF_TENTS = {
  hero: "https://static.wixstatic.com/media/731077_a78741637763494bbd7fafb556b3a007~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,enc_avif,quality_auto/IMG_4068_JPG.jpg",
  categories: [
    {
      name: "HARD SHELL ROOF TENTS",
      brand: "EEZI-AWN",
      sub: "Stealth · Blade · 41-year South African name",
      url: `${BASE}/hard-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_a78741637763494bbd7fafb556b3a007~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_a78741637763494bbd7fafb556b3a007~mv2.jpg",
    },
    {
      name: "SIDE OPENING TENTS",
      brand: "EEZI-AWN Sword",
      sub: "2 person & family sizes",
      url: `${BASE}/hard-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_5f236631cafd40c78912c25ac5a8f1ec~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_5f236631cafd40c78912c25ac5a8f1ec~mv2.jpg",
    },
    {
      name: "LIGHT WEIGHT HARD SHELLS",
      brand: "For smaller 4WDs & cars",
      sub: "Ultralight construction",
      url: `${BASE}/hard-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_6713f317251949aebd84e00ddbc44773~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_6713f317251949aebd84e00ddbc44773~mv2.jpg",
    },
    {
      name: "SOFT SHELL CANVAS TENTS",
      brand: "EEZI-AWN Series 3",
      sub: "80% pack themselves. Premium SA canvas",
      url: `${BASE}/soft-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_9078596178b548788353961ca7e15cae~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_9078596178b548788353961ca7e15cae~mv2.jpg",
    },
    {
      name: "QUICK PITCH ROOF TENTS",
      brand: "Quick Pitch SA",
      sub: "Premium hard shell — globally proven",
      url: `${BASE}/hard-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_61fccbb7272c42c5ac76a5b406219a04~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_61fccbb7272c42c5ac76a5b406219a04~mv2.jpg",
    },
    {
      name: "EEZI-AWN HYBRID",
      brand: "Ultralight 45kg",
      sub: "Serious tent from a 41-year world brand",
      url: `${BASE}/hard-shell-roof-tents`,
      image: "https://static.wixstatic.com/media/731077_44986a2b65894be6b119695de0b32e31~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_44986a2b65894be6b119695de0b32e31~mv2.jpg",
    },
  ],
};

export const AWNINGS = {
  hero: "https://static.wixstatic.com/media/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,enc_avif,quality_auto/20251210_144141.jpg",
  categories: [
    {
      name: "QUICK PITCH FREESTANDING",
      brand: "Quick Pitch SA",
      sub: "Woven canvas & aluminised technical canvas",
      url: `${BASE}/awnings`,
      image: "https://static.wixstatic.com/media/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg",
    },
    {
      name: "WIND DEFLECTORS",
      brand: "Quick Pitch",
      sub: "Reduce highway drag on roof tents",
      url: `${BASE}/product-page/quick-pitch-roof-tent-wind-deflector`,
      image: "https://static.wixstatic.com/media/731077_c946548725c04b87a0a4057bd0abe32b~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_c946548725c04b87a0a4057bd0abe32b~mv2.jpg",
    },
    {
      name: "AWNING LED LIGHTING",
      brand: "Quick Pitch",
      sub: "Under-awning lighting kits",
      url: `${BASE}/product-page/led-light-kit-for-quick-pitch-awnings`,
      image: "https://static.wixstatic.com/media/731077_4a559f2576844b49b97dcc861cf6e823~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_4a559f2576844b49b97dcc861cf6e823~mv2.jpg",
    },
    {
      name: "AWNING MOUNTS & BRACKETS",
      brand: "EEZI-AWN",
      sub: "K9-compatible mounts for every setup",
      url: `${BASE}/awning-brackets-roof-tent-mounts`,
      image: "https://static.wixstatic.com/media/731077_21fde358644642c280c639bc66c23116~mv2.webp/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/731077_21fde358644642c280c639bc66c23116~mv2.webp",
    },
  ],
};

// Overland Gear hub page retired (Feb 2026) — its unique sub-categories now
// live directly in the Shop mega-dropdown (see SHOP_SUBLINKS in Layout.jsx).
// Ground Tents, Bull Bars and Jimny Store were previously duplicated here too
// (already top-level Shop/nav items) — removed to eliminate that overlap.
